import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export interface AccountingStatus {
  connected: boolean;
  provider?: string;
  companyName?: string;
  lastSyncAt?: string;
  entityCount?: number;
  /** Actively running OR queued to run imminently. */
  isSyncing?: boolean;
  /** Job exists but is waiting on a future nextAttemptAt (error backoff / daily pause). */
  paused?: boolean;
  /** When a paused job will next be attempted (ISO). */
  nextAttemptAt?: string | null;
  /** Latest job status: PENDING | RUNNING | COMPLETED | FAILED | null. */
  status?: string | null;
  /** Latest job kind: FULL | INCREMENTAL. */
  kind?: string;
  /** Sync progress (entities). */
  doneEntities?: number;
  totalEntities?: number;
  rowsSynced?: number;
  lastError?: string | null;
}

export async function getAccountingStatus(): Promise<AccountingStatus> {
  const res = await apiClient.get<AccountingStatus>(ENDPOINTS.accounting.status);
  return res.data;
}

export async function getQBOConnectUrl(): Promise<{ authUrl: string }> {
  const res = await apiClient.get<{ authUrl: string }>(ENDPOINTS.accounting.qboConnect);
  return res.data;
}

export async function getXeroConnectUrl(): Promise<{ authUrl: string }> {
  const res = await apiClient.get<{ authUrl: string }>(ENDPOINTS.accounting.xeroConnect);
  return res.data;
}

export async function disconnectAccounting(provider: string): Promise<void> {
  await apiClient.post(ENDPOINTS.accounting.disconnect(provider));
}

export async function syncAccounting(full = false): Promise<void> {
  await apiClient.post(full ? `${ENDPOINTS.accounting.sync}?full=true` : ENDPOINTS.accounting.sync);
}

export async function getEntity(entityId: string): Promise<{
  entityType: string;
  provider: string;
  externalId: string;
  data: Record<string, unknown>;
}> {
  const res = await apiClient.get(ENDPOINTS.accounting.entity(entityId));
  return res.data as {
    entityType: string;
    provider: string;
    externalId: string;
    data: Record<string, unknown>;
  };
}
